<template>
  <TableRow>
    <TableCell
      :colspan="colspan"
      class="empty-table-cell"
    >
      <div class="flex items-center justify-center py-3">
        <slot />
      </div>
    </TableCell>
  </TableRow>
</template>
<script>
import TableRow from './TableRow.vue'
import TableCell from './TableCell.vue'

export default {
  components: {
    TableRow,
    TableCell
  },
  props: {
    colspan: {
      type: Number,
      default: 1
    }
  }
}
</script>

